export default "__VITE_ASSET__DWi5P06n__"